import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaLock, FaUser } from "react-icons/fa6";
import {
  sendOtp,
  verifyOtp,
} from "../../Redux/NewHire/Action";
import Swal from "sweetalert2";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [isOtpVisible, setIsOtpVisible] = useState(false);
  const navigate = useNavigate();
  const [timer, setTimer] = useState(30);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);



  const [passwordData, setPasswordData] = useState({
    username: "",
    newPassword: "",
    confirmPassword: "",
    otp: "",
  });

  useEffect(() => {
    let interval;
    if (isOtpVisible && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    if (timer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isOtpVisible, timer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prevValues) => {
      const updatedValues = { ...prevValues, [name]: value };

      if (name === "newPassword" || name === "confirmPassword") {
        if (
          updatedValues.newPassword &&
          updatedValues.confirmPassword &&
          updatedValues.newPassword !== updatedValues.confirmPassword
        ) {
          setErrorMessage("New Password and Confirm Password did not match.");
          setIsSubmitDisabled(true);
        } else {
          setErrorMessage("");
          setIsSubmitDisabled(
            !updatedValues.otp ||
            !updatedValues.newPassword ||
            !updatedValues.confirmPassword
          );
        }
      }
      return updatedValues;
    });
  };

  const handleSendOtp = (e) => {
    if (e) e.preventDefault();
    if (!passwordData.username.trim()) {
      Swal.fire({
        icon: "error",
        title: "Input Required",
        text: "Please enter your username before proceeding.",
      });
      return;
    }
    Swal.fire({
      title: "Sending OTP...",
      text: "Please wait while we generate and send the OTP to your email.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setTimer(30);
    dispatch(sendOtp(passwordData.username))
      .then(async (response) => {
        if (response.statusMessage === "SUCCESS") {
          Swal.fire({
            icon: "success",
            title: "OTP Sent",
            timer: 2000,
            text: response.statusDesc,
          });
          setIsOtpVisible(true);
        } else if (response.statusMessage === "FAILURE" && response.statusCode === "88") {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.statusDesc,
          });
          setIsOtpVisible(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.statusDesc,
          });
          setIsOtpVisible(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "An error occurred while sending OTP.",
        });
      });
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    const validateOtp = {
      userName: passwordData.username,
      newPassword: passwordData.newPassword,
      otp: passwordData.otp
    }
    dispatch(verifyOtp(validateOtp))
      .then((response) => {
        if (response.statusMessage === "SUCCESS") {
          Swal.fire({
            icon: "success",
            title: "Success",
            html: `${response.statusDesc}.<br>Please log in again to continue.`,
          });
          navigate("/signin");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.statusDesc,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "An error occurred while submit.",
        });
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };


  return (
    <div>
      <div className="login">
        <div className="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-3 mx-auto">
          <div className="card-login">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 p-2 mt-5 image-container">
                <img
                  width="100%"
                  height="100%"
                  alt="logo"
                  src="./images/login-bg.jpg"
                />
              </div>

              <div className="col-lg-1 d-none d-lg-block"></div>
              <div className="col-lg-5 col-md-6 col-sm-12 mt-5">
                <form>
                  <div className="form-group">
                    <div className="card-logo p-4">
                      <div className="form-logo">
                        <img
                          src="./images/Hrms.jpg"
                          alt="profile-image"
                          className="image"
                        />
                      </div>


                      {!isOtpVisible && (
                        <div className="mb-3 input-group">
                          <span className="input-group-text">
                            <FaUser />
                          </span>
                          <input
                            name="username"
                            type="text"
                            className="form-control"
                            placeholder="Enter your Username"
                            value={passwordData.email}
                            onChange={handleChange}
                          />
                        </div>
                      )}
                      {!isOtpVisible && (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={handleSendOtp}
                        >
                          Send OTP
                        </button>
                      )}

                      {isOtpVisible && (
                        <>
                          <div className="mb-3 text-primary">
                            <strong>Username: </strong>
                            <span>{passwordData.username}</span>
                          </div>
                          <div className="mb-3 input-group">
                            <span className="input-group-text">
                              <FaLock />
                            </span>
                            <input
                              name="otp"
                              type="text"
                              className="form-control"
                              placeholder="Enter OTP"
                              value={passwordData.otp}
                              onChange={handleChange}
                              maxLength={4}
                            />
                          </div>
                          <div className="mb-3 input-group">
                            <span className="input-group-text">
                              <FaLock />
                            </span>
                            <input
                              name="newPassword"
                              type="password"
                              className="form-control"
                              placeholder="Enter New Password"
                              value={passwordData.newPassword}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                            />
                          </div>
                          <div className="mb-3 input-group">
                            <span className="input-group-text">
                              <FaLock />
                            </span>
                            <input
                              name="confirmPassword"
                              type="password"
                              className="form-control"
                              placeholder="Confirm New Password"
                              value={passwordData.confirmPassword}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                            />
                          </div>
                          {errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={handleOtpSubmit}
                            disabled={isSubmitDisabled}
                          >
                            Submit
                          </button>

                          {timer > 0 && (
                            <div className="mt-2">
                              Resend OTP in {timer} seconds
                            </div>
                          )}

                          {timer === 0 && (
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => {
                                setTimer(30); // Reset timer
                                handleSendOtp();
                              }}
                            >
                              Resend OTP
                            </button>
                          )}
                        </>
                      )}
                      <div className="mt-3">
                        <button
                          type="button"
                          className="btn btn-link"
                          onClick={() => navigate("/signin")}
                        >
                          Back to Login
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-column">
            <h3 className="footer-title">About Us</h3>
            <p className="footer-text">
              We are committed to providing the best services to our customers.
              Learn more about our journey and values.
            </p>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="/#">Home</a>
              </li>
              <li>
                <a href="/#">Services</a>
              </li>
              <li>
                <a href="/#">About</a>
              </li>
              <li>
                <a href="/#">Contact</a>
              </li>
              <li>
                <a href="/#">Blog</a>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Contact Us</h3>
            <ul className="footer-contact">
              <li>
                <span>Phone:</span> <a href="tel:+91 7676621612">7676621612</a>
              </li>
              <li>
                <span>Email:</span>{" "}
                <a href="mailto:info@elexyt.com">info@elexyt.com</a>
              </li>
              <li>
                <span>Address:</span> Bangalore, Karnataka
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-social">
              <a href="https://www.elexyt.com/" className="footer-social-link">
                <img src="./images/facebook.png" alt="fb"></img>
              </a>
              <a
                href="https://www.linkedin.com/company/elexyt?trk=organization_guest_main-feed-card_feed-article-content"
                className="footer-social-link"
              >
                <img src="./images/linked-in.png" alt="fb"></img>
              </a>
              <a href="https://www.elexyt.com/" className="footer-social-link">
                <img src="./images/twitter.png" alt="fb"></img>
              </a>
              <a href="https://www.elexyt.com/" className="footer-social-link">
                <img src="./images/instagram.png" alt="fb"></img>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2024 Developed By: Elexyt PVT. LTD. | All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ForgotPassword;
